import React, { useEffect, useRef, useState } from 'react';
import style from './AddAlertForm.module.css';
import { AlertFormStore, AlertFormProvider } from './alertFormClass';
import { DeactivateField } from './formComponents/deactivate/DeactivateField';
import { DirectionField } from './formComponents/direction/DirectionField';
import { RepeatingField } from './formComponents/repeating/RepeatingField';
import { SetupDetails } from './formComponents/setup/setupDetails/SetupDetails';
import { SetupField } from './formComponents/setup/SetupField';
import { AddFilter } from './formComponents/setupFilters/setupFiltersSection/AddFilter';
import { SetupFiltersSection } from './formComponents/setupFilters/setupFiltersSection/SetupFiltersSection';
import { SymbolField } from './formComponents/symbol/SymbolField';
import { AddAlert } from './formComponents/addAlert/AddAlert';
import { UtilitySection } from './formComponents/utilitySection/UtilitySection';
import { WatchlistSelect } from './formComponents/watchlistSelect/WatchlistSelect';
import { useAlertsStore } from '../../../../../../stores/websocketStore/_alertsStore';

export const AddAlertForm = () => {
  const [loadingStore, setLoadingStore] = useState(true);
  const storeRef = useRef(null);
  const { dataSource } = useAlertsStore();

  useEffect(() => {
    storeRef.current = new AlertFormStore();
    setLoadingStore(false);
  }, []);

  useEffect(() => {
    if (storeRef.current) {
      storeRef.current.setDataSource(dataSource);
    }
  }, [dataSource]);
  if (storeRef.current === null || loadingStore) return null;
  return (
    <AlertFormProvider store={storeRef.current}>
      <div className={style.container}>
        <UtilitySection />
        <WatchlistSelect />
        <SymbolField />
        <DirectionField />
        <RepeatingField />
        <DeactivateField />
        <SetupField />
        <SetupDetails />
        <AddFilter />
        <SetupFiltersSection />
        <AddAlert />
      </div>
    </AlertFormProvider>
  );
};
